import { render, staticRenderFns } from "./ControlPanelCircular.vue?vue&type=template&id=24858772&scoped=true"
import script from "./ControlPanelCircular.vue?vue&type=script&lang=js"
export * from "./ControlPanelCircular.vue?vue&type=script&lang=js"
import style0 from "./ControlPanelCircular.vue?vue&type=style&index=0&id=24858772&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24858772",
  null
  
)

export default component.exports